const getters = {
  contactSelectedId(state) {
    return state.data.contactSelected.id;
  },
  getValidationState(state) {
    return state;
  }
};

export default getters;
